<template>
    <div class="login-bg">
        <w-app
            id="app"
            class="justify-space-between basis-zero justify-center align-center login-bg"
        >
            <header></header>

            <main class="grow align-self-center mt10">
                <w-card class="zloginbox-title">
                    <div class="zloginbox-title-top">iHasil</div>
                    <div class="zloginbox-title-bottom">
                        Aduan / Maklum Balas
                    </div>
                </w-card>

                <w-card class="zloginbox">
                    <template #buttons />

                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="hantar"
                        @success="onSuccess"
                    >
                        <z-lookup
                            outline
                            label="Jabatan/Agensi"
                            placeholder="Sila Pilih Jabatan/Agensi"
                            :url="service_utiliti + 'lookup/jabatans'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_jabatan_id"
                        >
                        </z-lookup>

                        <div class="spacer"></div>

                        <z-lookup
                            outline
                            label="Klasifikasi"
                            placeholder="Sila Klasifikasi"
                            :url="service_utiliti + 'lookup/aduan'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_aduan_id"
                        >
                        </z-lookup>

                        <div class="spacer"></div>

                        <z-input
                            outline
                            label="Nama *"
                            type="text"
                            placeholder="Sila isi nama"
                            name="nama"
                            v-model="form.nama"
                            :validators="[validators.required]"
                        />
                        <div class="spacer"></div>
                        <z-input
                            outline
                            label="Emel *"
                            class="mt3"
                            type="email"
                            placeholder="Sila isi emel"
                            name="email"
                            v-model="form.emel"
                            :validators="[
                                validators.required,
                                validators.email,
                            ]"
                        />
                        <div class="spacer"></div>
                        <z-input
                            outline
                            label="No Telefon *"
                            class="mt3"
                            type="text"
                            placeholder="Sila isi no telefon"
                            name="no_telefon"
                            v-model="form.no_telefon"
                            :validators="[validators.required]"
                        />
                        <div class="spacer"></div>
                        <br />
                        <w-textarea
                            outline
                            label="Catatan  *"
                            no-autogrow
                            resizable
                            v-model="form.keterangan"
                            name="keterangan"
                            placeholder="Sila Nyatakan Aduan / Penghargaan / Pertanyaan / Cadangan"
                            :validators="[validators.required]"
                            rows="3"
                        >
                        </w-textarea>
                        <div class="spacer"></div>
                        <z-input
                            outline
                            class="mt3"
                            type="file"
                            placeholder="Tiada Fail Dipilih"
                            v-model="files"
                            :validators="[validators.required]"
                            label="Sila Muatnaik Gambar/Fail  *"
                        />

                        <div class="mt5 mb5"></div>

                        <w-flex justify-center align-center class="mt5">
                            <w-button
                                class="my2 btn-zloginbox grow"
                                :loading="dialog.loading"
                                :disabled="btnStatus"
                                @click="$refs.form.validate() && !form.sent"
                            >
                                <w-icon class="mr2" xs
                                    >fal fa-sign-in-alt</w-icon
                                >
                                Hantar
                            </w-button>
                        </w-flex>
                        <w-flex justify-center align-center>
                            <w-flex justify-center align-center>
                                <w-button
                                    bg-color="grey-light5--bg"
                                    class="my2 btn-zloginboxback grow"
                                    type=""
                                    @click="kembali"
                                >
                                    <w-icon class="mr2" xs
                                        >fal fa-arrow-left</w-icon
                                    >
                                    Kembali
                                </w-button>
                            </w-flex>
                        </w-flex>
                    </w-form>
                </w-card>

                <div class="zloginbox-title-footer">
                    <b>#HAK CIPTA TERPELIHARA © 2022 KERAJAAN NEGERI KEDAH</b>
                </div>
            </main>

            <footer></footer>
        </w-app>
    </div>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    data() {
        return {
            resourceurl: this.service_utiliti + "aduan",
            btnStatus: false,
            validators: {
                required: (value) => !!value || "Medan Ini Wajib",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila semak format email",
            },
            files: [],
        };
    },
    methods: {
        hantar() {
            if (
                this.form.lkp_jabatan_id &&
                this.form.lkp_aduan_id &&
                this.form.nama &&
                this.form.emel &&
                this.form.no_telefon &&
                this.form.keterangan &&
                this.files
            ) {
                this.btnStatus = true;
                this.$zcomm
                    .post(this.resourceurl, this.form)
                    .then((res) => {
                        if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd();
                        }
                        this.upload(res.id);
                        this.$zutil.notify("Aduan Telah Berjaya Dihantar");
                        this.$inertia.visit(this.$route("login"));
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {});
            }
        },

        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\Aduan");
            formData.append("model_id", id);
            console.log(formData);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Aduan Telah Berjaya Dihantar");
                })
                .catch((err) => {})
                .finally(() => {});
        },

        kembali() {
            this.$inertia.visit(this.$route("login"));
        },
    },
    watch: {
        //   files: function(val) {
        //     console.log(val);
        //     console.log('work');
        // },
    },
};
</script>

<style>
.w-select__menu {
    z-index: 999999;
}

#app {
    flex-direction: column;
}
.login-bg {
    background: url(/images/landpage.jpg) !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
}
.zloginbox {
    width: 500px;
    background: inherit !important;
}
.zloginbox .w-card__content {
    background: #fff;
}
.zloginbox .w-toolbar {
    background-color: #0c213ab8;
    color: #fff;
}
.zloginbox .w-input__input-wrap {
    margin-top: 25px;
}
.zloginbox .w-input__label--inside {
    font-size: 15px;
    margin-top: -5px;
    margin-left: -5px;
}
.zloginbox .w-input__input-wrap--box {
    height: 33px;
}
.zloginbox .w-card__content {
    padding: 16px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}
.w-card.zloginbox-title {
    background: #0c213ab8;
    color: #fff;
    text-align: center;
    background: #3d272ab0;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-top: 1px solid #8c6c68;
    border-left: 1px solid #8c6c68;
    border-right: 1px solid #8c6c68;
    margin-top: 150px;
}
.zloginbox-title-top {
    font-weight: bold;
    font-size: 15px;
    text-shadow: 1px 1px black;
}
.zloginbox-title-bottom {
    margin-bottom: 10px;
    margin-top: 5px;
}
.zloginbox-logo img {
    height: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.btn-zloginbox {
    color: #fff;
    background-color: #1761fd !important;
    border-color: #1761fd !important;
    font-size: 13px !important;
    padding: 15px;
}
.btn-zloginboxback {
    color: rgb(8, 1, 1);
    border-color: #0000001a !important;
    font-size: 13px !important;
    padding: 15px;
}
.zloginbox-title-footer {
    text-align: center;
    font-size: 13px;
    color: #fff;
    margin-top: 10px;
    text-shadow: 1px 1px black;
}
</style>
